import styled from 'styled-components';
import { Button, Input, Radio, Typography } from '@libs/components';

export const AddCryptoAddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 3.6rem 3.6rem 2.8rem;
  max-width: 50rem;
  width: 100%;
  justify-self: center;

  ${({ theme }) => theme.media.laptop`
  
  width:50rem;`}
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 1.2rem;
  width: 100%;
  padding: 1.6rem;

  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  border-radius: ${({ theme }) => theme.borderRadius.x3};
`;

export const AddCryptoAddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  gap: 1.6rem;
  margin-top: 2rem;
`;

export const EditCryptoAddressesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 2rem 2rem 3.6rem 2rem;

  max-width: 50rem;
  justify-self: center;
  ${({ theme }) => theme.media.tablet`
  padding: 2rem 3.6rem 3.6rem 3.6rem;

  width:50rem;
  `};
`;

export const AddressOption = styled(Radio)`
  border-radius: 0;
  border: unset;
  padding: 1.6rem;
  height: unset;
  min-height: 7.5rem;
  cursor: auto;

  .description-text {
    word-break: break-word;
  }

  :hover {
    background-color: ${({ theme }) => theme.colors.surface.default};
  }

  background-color: ${({ theme, checked }) =>
    checked
      ? theme.colors.interactive.secondary
      : theme.colors.surface.default};
`;

export const OptionsWrapper = styled.div`
  margin-top: 3.2rem;
  margin-bottom: 3.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  border-radius: ${({ theme }) => theme.borderRadius.x4};
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  width: 100%;

  ${AddressOption} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};
  }
  ${AddressOption}:first-child {
    border-top-left-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  }
  ${AddressOption}:last-child {
    border-top-left-radius: unset;
    border-bottom: none;
  }
`;

export const AddressEditActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const EditAddressDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.6rem;
  margin-bottom: 2rem;
  gap: 0.4rem;
  width: 100%;
  align-items: center;

  border-radius: ${({ theme }) => theme.borderRadius.x3};
  background-color: ${({ theme }) => theme.colors.surface.buttonBackground};
`;

export const EditAddressDescriptionTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
`;

export const EditNameButton = styled(Button)`
  margin-top: 4.4rem;
`;

export const EditNameInput = styled(Input)`
  border-radius: ${({ theme }) => theme.borderRadius.x3};
`;

export const DeleteCryptoAddressWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-self: center;
  max-width: 50rem;
  width: 100%;
  padding: 3.2rem;

  ${({ theme }) => theme.media.laptop`
  
  
  width:50rem;`}
`;

export const DeleteAddressDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
`;

export const DeleteAddressButtonsWRapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  margin-top: 2rem;
`;

export const DeleteAddressIconNetworkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  width: 100%;

  padding: 1.6rem;
  background-color: ${({ theme }) => theme.colors.surface.buttonBackground};
  border-radius: ${({ theme }) => theme.borderRadius.x3};
`;

export const CustomTypography = styled(Typography)`
  word-break: break-word;
`;
